import AuthService from "../services/auth.service";

export default async function FetchGetDataWithAuthNEW(url) {

	var restData = {
		successful: false,
		status: '',
		message: '',
		data: []
	};

	var currentUser = AuthService.getCurrentUser();
	var token = "";
	if (currentUser != null) {
		token = currentUser.accessToken;
	}

	url = "/rest" + url;
	
	await fetch(url, {
    method: 'GET',
    withCredentials: true,
    credentials: 'include',
    headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
	})
	.then(async response => {
		const isJson = response.headers.get('content-type')?.includes('application/json');
		const data = isJson ? await response.json() : {};

		if (response.status !== 200) {
			restData.successful = false;
			restData.status = response.status;
			restData.message = data?.message ?? "";
			restData.error = data?.error ?? null; // <- bezpieczne odczytanie error
		} else {
			restData.successful = true;
			restData.status = response.status;
			restData.message = data?.message ?? "";
			restData.error = data?.error ?? null; // <- jeśli istnieje
			restData.data = data;
		}
	}, error => {
		const resMessage = error?.response?.data?.message ?? error?.message ?? error.toString();
		const resError = error?.response?.data?.error ?? null;

		restData.successful = false;
		restData.message = resMessage;
		restData.error = resError;

		this.setState({
			successful: false,
			message: resMessage
		});
	});

	if (restData.status == 401) {
		AuthService.logout();
		window.location.href = "/login";
	}
	return restData;
}



